import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const TrimIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon" clipPath="url(#clip0_988_8793)">
        <path
          id="Vector"
          d="M2.5 3.38281V8.38281M2.5 13.3828V8.38281M2.5 8.38281H1"
          stroke={fillColor || '#6C6C6C'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M13.5 3.38281V8.38281M13.5 13.3828V8.38281M13.5 8.38281H15"
          stroke={fillColor || '#6C6C6C'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle id="Ellipse 434" cx="5" cy="8.38281" r="1" fill={fillColor || '#6C6C6C'} />
        <circle id="Ellipse 435" cx="8" cy="8.38281" r="1" fill={fillColor || '#6C6C6C'} />
        <circle id="Ellipse 436" cx="11" cy="8.38281" r="1" fill={fillColor || '#6C6C6C'} />
      </g>
      <defs>
        <clipPath id="clip0_988_8793">
          <rect width="16" height="16" fill={fillColor || 'white'} transform="translate(0 0.382812)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { TrimIcon };
